import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../magpiie-client/client';
import type { AppRawRule } from '../../abilities/types';

export const fetchOrganizationAbilities = createAsyncThunk(
  'abilities/fetchOrganizationAbilities',
  async (orgId: number, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET(
      '/v2/organizations/{orgId}/abilities',
      { params: { path: { orgId } } }
    );
    if (error) {
      return rejectWithValue(
        (error as any).message || 'Failed to fetch organization abilities'
      );
    }
    return { orgId, rules: (data ?? []) as unknown as AppRawRule[] };
  }
);

export const fetchChannelAbilities = createAsyncThunk(
  'abilities/fetchChannelAbilities',
  async (channelId: number, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET(
      '/v2/channels/{channelId}/abilities',
      { params: { path: { channelId } } }
    );
    if (error) {
      return rejectWithValue(
        (error as any).message || 'Failed to fetch channel abilities'
      );
    }
    return { channelId, rules: (data ?? []) as unknown as AppRawRule[] };
  }
);

/**
 * Revision-scope CASL rules. Rules are channel-uniform — the backend factory
 * emits the same rule set for every revision in a channel; per-revision
 * differences are decided at evaluation time by the rule's `conditions` block
 * (invite_only, creator_id, invited_users, reviewers, assignee_id). So one
 * fetch per channel covers the whole revision/draft/issue/folder/tag UI.
 */
export const fetchChannelRevisionAbilities = createAsyncThunk(
  'abilities/fetchChannelRevisionAbilities',
  async (channelId: number, { rejectWithValue }) => {
    const { data, error } = await apiClient.GET(
      '/v2/channel/{channelId}/revision/abilities',
      { params: { path: { channelId } } }
    );
    if (error) {
      return rejectWithValue(
        (error as any).message || 'Failed to fetch revision abilities'
      );
    }
    return { channelId, rules: (data ?? []) as unknown as AppRawRule[] };
  }
);
